export type Environment = 'platdev' | 'platstaging' | 'platprod';
